import { CAT_RUNNING_HITBOX_INSETS } from '../constants'

export const getInsetHitbox = (entity, inset) => ({
  x: entity.x + inset.left,
  y: entity.y - entity.height + inset.top,
  width: Math.max(0, entity.width - inset.left - inset.right),
  height: Math.max(0, entity.height - inset.top - inset.bottom),
})

export const getPlayerHitbox = (player) =>
  getInsetHitbox(player, CAT_RUNNING_HITBOX_INSETS.player)

export const getGroundObstacleHitbox = (obstacle) =>
  getInsetHitbox(obstacle, CAT_RUNNING_HITBOX_INSETS.obstacleGround)

export const getCrowCollisionHitbox = (obstacle) =>
  getInsetHitbox(obstacle, CAT_RUNNING_HITBOX_INSETS.obstacleCrow)

export const getObstacleHitbox = (obstacle) =>
  obstacle.kind === 'crow' ? getCrowCollisionHitbox(obstacle) : getGroundObstacleHitbox(obstacle)

export const getChuruHitbox = (churu) =>
  getInsetHitbox(churu, CAT_RUNNING_HITBOX_INSETS.churu)

export const isRectOverlap = (a, b) =>
  a.x < b.x + b.width &&
  a.x + a.width > b.x &&
  a.y < b.y + b.height &&
  a.y + a.height > b.y

export const checkGroundObstacleCollision = (world) => {
  const playerHitbox = getPlayerHitbox(world.player)

  return world.obstacles.some((obstacle) => isRectOverlap(playerHitbox, getObstacleHitbox(obstacle)))
}
